module.exports = __webpack_public_path__ + "img/vk.7f5c8e62.svg";